import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState(location.state?.user ? "ok" : "checking");
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) return;
    (async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error("unauth");
        const u = await res.json();
        setUser(u);
        setState("ok");
      } catch {
        setState("no");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.state, navigate]);

  if (state === "checking") {
    return (
      <div className="min-h-screen bg-ink-900 grid place-items-center" data-testid="protected-loading">
        <Loader2 className="animate-spin text-acid" size={32} />
      </div>
    );
  }
  if (state !== "ok") return null;
  return children({ user });
}
